import { render, staticRenderFns } from "./ContactPicker.vue?vue&type=template&id=0f655bc9&scoped=true&"
import script from "./ContactPicker.vue?vue&type=script&lang=js&"
export * from "./ContactPicker.vue?vue&type=script&lang=js&"
import style0 from "./ContactPicker.vue?vue&type=style&index=0&id=0f655bc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f655bc9",
  null
  
)

export default component.exports